const MODAL_WRAP_SELECTOR = '.ant-modal-wrap'
const MODAL_ROOT_SELECTOR = '.ant-modal-root'
const MODAL_MASK_SELECTOR = '.ant-modal-mask'

const BASE_Z_INDEX = 1000
const Z_INDEX_STEP = 10

let initialized = false
let observer = null
let orderCounter = 0
let rafId = null

const visibleState = new WeakMap()
const openOrder = new WeakMap()

function isVisible(element) {
  if (!element || !document.body.contains(element)) {
    return false
  }

  const styles = window.getComputedStyle(element)
  return styles.display !== 'none' && styles.visibility !== 'hidden'
}

function getMaskByWrap(wrap) {
  const root = wrap.closest(MODAL_ROOT_SELECTOR)
  if (!root) {
    return null
  }

  return root.querySelector(MODAL_MASK_SELECTOR)
}

function getVisibleWraps() {
  return Array.from(document.querySelectorAll(MODAL_WRAP_SELECTOR)).filter(wrap => isVisible(wrap))
}

function reindexVisibleModals() {
  const wraps = getVisibleWraps()

  wraps.forEach(wrap => {
    const wasVisible = visibleState.get(wrap) === true

    if (!wasVisible) {
      visibleState.set(wrap, true)
      openOrder.set(wrap, ++orderCounter)
    }
  })

  wraps
    .sort((a, b) => {
      const aOrder = openOrder.get(a) || 0
      const bOrder = openOrder.get(b) || 0
      return aOrder - bOrder
    })
    .forEach((wrap, index) => {
      const wrapZIndex = BASE_Z_INDEX + index * Z_INDEX_STEP
      const mask = getMaskByWrap(wrap)

      wrap.style.zIndex = String(wrapZIndex)
      if (mask) {
        mask.style.zIndex = String(wrapZIndex - 1)
      }
    })

  Array.from(document.querySelectorAll(MODAL_WRAP_SELECTOR))
    .filter(wrap => !wraps.includes(wrap))
    .forEach(wrap => visibleState.set(wrap, false))
}

function scheduleReindex() {
  if (rafId !== null) {
    return
  }

  rafId = window.requestAnimationFrame(() => {
    rafId = null
    reindexVisibleModals()
  })
}

export function initModalZIndexManager() {
  if (initialized || typeof window === 'undefined' || !window.MutationObserver) {
    return
  }

  initialized = true

  scheduleReindex()

  observer = new MutationObserver(() => {
    scheduleReindex()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  })
}

export function destroyModalZIndexManager() {
  if (observer) {
    observer.disconnect()
    observer = null
  }

  if (rafId !== null) {
    window.cancelAnimationFrame(rafId)
    rafId = null
  }

  initialized = false
}
